import React, { createContext, useContext, useMemo } from 'react'

import { PayPalScriptOptions } from '@paypal/paypal-js'
import { PayPalScriptProvider } from '@paypal/react-paypal-js'

import braintreeContext from '@/context/braintree/context'

import { PaypalContextValue, PaypalState } from './types'
import { initialOptions } from './utils'

const defaultState: PaypalState = {
    paypalOptions: { ...initialOptions },
}

const defaultContextValue: PaypalContextValue = {
    state: defaultState,
}

const paypalContext = createContext<PaypalContextValue>(defaultContextValue)
const { Provider } = paypalContext

export const PaypalProvider: React.FC = ({ children }) => {
    const {
        selector: { btGatewayConfigSelector, clientToken },
    } = useContext(braintreeContext)
    const paypalClientId = btGatewayConfigSelector?.paypal?.clientId || ''

    const paypalOptions = useMemo<PayPalScriptOptions>(() => {
        return {
            ...initialOptions,
            vault: false,
            intent: 'authorize' as const,
            commit: true,
            clientId: paypalClientId,
            dataClientToken: clientToken,
        }
    }, [clientToken, paypalClientId])

    const contextValue: PaypalContextValue = useMemo(() => {
        return {
            state: {
                paypalOptions,
            },
        }
    }, [paypalOptions])

    if (!clientToken || !paypalClientId) return <> {children} </>

    return (
        <Provider value={contextValue}>
            <PayPalScriptProvider options={paypalOptions} data-testid="paypal-script-provider">
                {children}
            </PayPalScriptProvider>
        </Provider>
    )
}

export default paypalContext
